const GOOGLE_GENAI_INTEGRATION_NAME = "Google_GenAI";
const GOOGLE_GENAI_METHOD_REGISTRY = {
  "models.generateContent": { operation: "generate_content" },
  "models.generateContentStream": { operation: "generate_content", streaming: true },
  "models.embedContent": { operation: "embeddings" },
  "chats.create": { proxyResultPath: "chat" },
  "chat.sendMessage": { operation: "chat" },
  "chat.sendMessageStream": { operation: "chat", streaming: true }
};
const GOOGLE_GENAI_SYSTEM_NAME = "google_genai";

export { GOOGLE_GENAI_INTEGRATION_NAME, GOOGLE_GENAI_METHOD_REGISTRY, GOOGLE_GENAI_SYSTEM_NAME };
//# sourceMappingURL=constants.js.map
